<template>
  <scroll-container class="mpd-side-panel-page-json">
    <pre class="text-color-black">{{ JSON.stringify(json, null, 2) }}</pre>
  </scroll-container>
</template>

<script>
export default {
  props: ['json']
}
</script>

<style lang="less">
.mpd-side-panel-page-json {
  -moz-user-select: all;
  -webkit-user-select: all;
  -ms-user-select: all;
  user-select: all;
}
</style>
